var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar'),_c('Menu'),_c('div',{staticClass:"app-content content"},[_c('div',{staticClass:"content-wrapper"},[_c('router-view')],1)]),_c('div',{staticClass:"sidenav-overlay"}),_c('div',{staticClass:"drag-target"}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }